import store from '../'

let resource = store.defineResource({
  name: "assignments",
  relations: {
    belongsTo: {
      syncblastAsset: {
        localKey: "syncblastAssetId",
        localField: "syncblastAsset"
      }
    },
    hasOne: {
      rubrics: {
        localKey: "rubricsId",
        localField: "rubrics"
      },
      blastBackgrounds: {
        localKey: "blastBackgroundId",
        localField: "blastBackground"
      }
    },
    hasMany: {
      userAssignments: {
        localField: "userAssignments",
        foreignKey: "assignmentId"
      },
      questions: [
        {
          localField: "questions",
          localKeys: "questionIds"
        },
        {
          localField: "compQuestionIds",
          get (Resource, relationDef, instance, origGetter) {
            return _.chain(instance.questions).filter({key: "sb-background"}).map("id").value()
          }
        },
        {
          localField: "compQuestions",
          localKeys: "compQuestionIds"
        },
      ]
    }
  }
})

export default resource



// WEBPACK FOOTER //
// ./src/store/models/assignments.js